<template>
  <el-dialog
    class="dialogCls"
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :modal-append-to-body="appendToBody"
    :before-close="handleClose"
    :show-close="!disableClose">
    <component v-loading="compLoading" ref="comp" :key="timeStamp" :is="component" v-bind="componentProps"/>
    <span v-if="!footerDisable" slot="footer" class="dialog-footer">
      <el-button v-if="!disableClose" size="medium" @click="close">取 消</el-button>
      <el-button v-if="!read" :loading="confirmLoading" size="medium" type="primary" @click="confirm">{{ confirmText }}</el-button>
    </span>
  </el-dialog>

</template>

<script>
import {debounce, isFunction, isBoolean} from "@/utils/commonTools"

export default {
  name: "FormDialog",
  provide() {
    return {
      getDialogVInst: () => {
        return this
      },
      getReadState: () => {
        return this.read
      },
    }
  },
  data() {
    return {
      compLoading: false,
      dialogVisible: false,
      component: null,
      title: '',
      width: '35%',
      read: false,
      businessId: '',
      componentProps:{},
      timeStamp: Date.now(),
      confirmLoading: false,
      appendToBody: false,
      footerDisable: false,
      closeConfirm: true,
      disableClose: false,
      confirmText: '',
      promise: {
        resolve: null,
        reject: null
      }
    }
  },
  methods: {
    open(option) {
      this.component = option.component || null
      this.title = option.title || ''
      this.width = option.width || '35%'
      this.businessId = option.businessId || ''
      this.componentProps = option.componentProps || {}
      this.read = option.read ?? false
      this.appendToBody = option.appendToBody ?? false
      this.confirmText = option.confirmText ?? '确 定'
      this.footerDisable = option.footerDisable ?? false
      this.closeConfirm = option.closeConfirm ?? true
      this.disableClose = option.disableClose ?? false
      this.confirmLoading = false
      this.compLoading = false
      this.refreshComponent()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.loadData()
      })
      return new Promise((resolve, reject) => {
        this.promise.resolve = resolve
        this.promise.reject = reject
      })
    },
    refreshComponent() {
      this.timeStamp = Date.now()
    },
    async loadData() {
      let initFunc = this.$refs.comp.init
      if (initFunc && isFunction(initFunc)) {
        this.compLoading = true
        try {
          await initFunc(this.businessId)
        } finally {
          this.compLoading = false
        }
      }
    },
    submit: debounce(function () {
      new Promise((resolve, reject) => {
        let submitFunc = this.$refs.comp.submit
        if (!submitFunc || !isFunction(submitFunc)) {
          console.log('submitFunc reject')
          reject()
          return
        }
        submitFunc(resolve, reject)
      }).then((data) => {
        this.close()
        if (this.promise.resolve) {
          this.promise.resolve(data)
        }
      }).catch(() => {
        // if (this.promise.reject) {
        //   this.promise.reject()
        // }

      }).finally(() => {
        this.confirmLoading = false
      })
    }, 200),
    confirm() {
      this.confirmLoading = true
      this.submit()
    },
    close() {
      this.dialogVisible = false
      this.component = null
    },
    handleClose() {
      if (this.disableClose) {
        return
      }
      if (this.closeConfirm) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.close()
          })
          .catch(_ => {
          });
      } else {
        this.close()
      }

    }
  }
}
</script>


<style scoped lang="scss">
@import "@/assets/css/base-variables.scss";
::v-deep {
  .el-dialog__header *{
    //border-bottom: $--by-border-color-base 1px solid;
    //padding-bottom: 20px;
    font-size: 16px;
  }
  .el-dialog__headerbtn {
    top: 24px;
  }
  .el-dialog__body{
    padding: 15px 10px !important;
  }
  .el-dialog__body *{
    font-size:12px !important;
  }
  .el-input-number.is-without-controls .el-input__inner{
    height: 40px;
  }
  .el-table--enable-row-transition .el-table__body td.el-table__cell{
    padding: 5px 0;
  }
  .el-table td.el-table__cell div{
    //padding-top: 5px;
    //padding-left: 5px;
    //padding-right: 5px;
  }
}
</style>
